import React, { useCallback } from 'react'
import {
  Text,
} from 'components'
import { Select, SelectProps } from 'components/Select'
import { Box, BoxProps } from 'components/Box'
import { SetFilters, Filters, FilterOnChange } from 'hooks/useFilters'

export type SelectFilterProps<T extends object, D extends object, K extends keyof T = keyof T> = SelectProps & {
  filterName: string,
  filterDefinitions: Filters<T, D, K>,
  filters: T,
  row?: boolean
  hideLabel?: boolean
  sx?: BoxProps['sx']
  setFilters: SetFilters<T>
}

export function SelectFilter<T extends object, D extends object, K extends keyof T = keyof T>(props: SelectFilterProps<T, D, K>) {
  const { filterName, filterDefinitions, filters, sx, fullWidth, size, hideLabel=false, setFilters } = props
  const filterDefinition = filterDefinitions.find((definition) => definition.name === filterName)

  const onChange: FilterOnChange<object> = useCallback((value) => {
    return { [filterName]: [ value ] }
  }, [filterName])


  return <Box width={fullWidth ? '100%' : 'auto'} sx={sx}>
    { !hideLabel && <Text variant="subtitle1" fontWeight="medium" pb={2}>{ filterDefinition.label }</Text> }

    { (!filterDefinition.options || filterDefinition.options.length === 0) && <Text variant="caption">No filter options found in your current current search. Try expanding your other filters.</Text> }

    <Select
      options={filterDefinition.options.map((opt) => ({ value: opt.value, label: opt.key }))}
      value={filters[filterName]}
      onChange={(e) => setFilters((filterDefinition.onChange || onChange)(e.target.value as string, filters))}
      fullWidth={fullWidth}
      size={size}
    />
  </Box>
}


export default SelectFilter
